import React from 'react';

import '../styles/PolicyPages.css';

function PrivacyPolicy() {
  return (
    <div className="policy-container">
      <h1>Privacy Policy</h1>
      <p className="last-updated">Last Updated: December 5, 2025</p>

      <section>
        <h2>1. Information We Collect</h2>
        <p>We collect information you provide directly to us when you create an account, make a purchase, or contact us. This includes:</p>
        <ul>
          <li>Name and contact information (email, phone, address)</li>
          <li>Payment information (processed securely through Razorpay)</li>
          <li>Order history and preferences</li>
          <li>Device and browsing information</li>
        </ul>
      </section>

      <section>
        <h2>2. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Process and fulfill your orders</li>
          <li>Communicate with you about your orders and account</li>
          <li>Improve our products and services</li>
          <li>Send you promotional communications (with your consent)</li>
          <li>Prevent fraud and enhance security</li>
        </ul>
      </section>

      <section>
        <h2>3. Information Sharing</h2>
        <p>
          We do not sell your personal information. We share your information only with:
        </p>
        <ul>
          <li>Payment processors (Razorpay) to process transactions</li>
          <li>Shipping partners to deliver your orders</li>
          <li>Service providers who assist in our operations</li>
          <li>Law enforcement when required by law</li>
        </ul>
      </section>

      <section>
        <h2>4. Data Security</h2>
        <ul>
          <li>We implement appropriate security measures to protect your personal information</li>
          <li>However, no method of transmission over the Internet is 100% secure</li>
        </ul>
      </section>

      <section>
        <h2>5. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access and update your personal information</li>
          <li>Request deletion of your account</li>
          <li>Opt-out of marketing communications</li>
          <li>Request a copy of your data</li>
        </ul>
      </section>

      <section>
        <h2>6. Cookies</h2>
        <ul>
          <li>We use cookies to enhance your browsing experience</li>
          <li>Analyze site traffic</li>
          <li>Remember your preferences</li>
        </ul>
      </section>

      <section>
        <h2>7. Contact Us</h2>
        <ul>
          <li>For questions about this Privacy Policy, please contact us</li>
          <li><strong>Email:</strong> support@kalingastore.shop</li>
          <li><strong>Address:</strong> 12A, Old Vijay Nagar, Ghaziabad, Uttar Pradesh - 201001</li>
        </ul>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
